import { useMutation } from "react-query";
import { upsertTraumaHistory } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

const useUpsertTraumaHistory = (options: Record<string, any> = {}) => {
  const { onSuccess = () => {}, onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({ clientId, payload }: { clientId: number; payload: Record<string, any> }) =>
      upsertTraumaHistory(clientId, payload),
    {
      onSuccess: (response, variables) => {
        showToast({ message: "Trauma history saved successfully." });
        onSuccess(response, variables);
      },
      onError: (error: any) => {
        const errorMessage =
          error?.response?.data?.error || "Failed to save trauma history";
        showToast({ message: errorMessage, errorState: true });
        onError(error);
      },
      ...otherOptions,
    }
  );

  return {
    upsertTraumaHistoryMutation: mutate,
    isUpsertTraumaHistoryLoading: isLoading,
    ...rest,
  };
};

export default useUpsertTraumaHistory;
